export default __webpack_public_path__ + "static/media/tg.7f369bdc.svg";